import React from "react";
import Icon from "@mdi/react";
import {
  mdiEmailCheckOutline,
  mdiEmailOffOutline,
  mdiEmailOutline,
  mdiSendVariantOutline,
} from "@mdi/js";
import { EMAIL_STATUS } from "../utils/emailAutomationHelpers";

const ICON_MAP = {
  [EMAIL_STATUS.SENT]: mdiEmailCheckOutline,
  [EMAIL_STATUS.FAILED]: mdiEmailOffOutline,
  [EMAIL_STATUS.PENDING]: mdiEmailOutline,
  [EMAIL_STATUS.READY]: mdiSendVariantOutline,
  [EMAIL_STATUS.SENDING]: mdiEmailOutline,
  [EMAIL_STATUS.CANCELLED]: mdiEmailOutline,
};

const EmailStatusIcon = ({ status, size = 1, color, className }) => {
  const path = ICON_MAP[status] || ICON_MAP[EMAIL_STATUS.PENDING];

  return (
    <Icon
      path={path}
      size={size}
      color={color}
      className={className}
    />
  );
};

export default EmailStatusIcon;
